import { render } from "./MyHeader.vue?vue&type=template&id=18167e15&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=18167e15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18167e15"

export default script